import 'react-native-gesture-handler';
import 'reflect-metadata';
import { createDrawerNavigator } from '@react-navigation/drawer';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { Platform, StatusBar, Text, useWindowDimensions, View } from 'react-native';
import { Provider as PaperProvider } from 'react-native-paper';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import socketIOClient from 'socket.io-client';
import empresaApi from './src/apis/empresaApi';
import colors from './src/colors';
import AdicionarProdutoPage from './src/components/AdicionarProdutoPage/AdicionarProdutoPage';
import CadastroPage from './src/components/CadastroPage/CadastroPage';
import { DrawerContent } from './src/components/Drawer/DrawerContent';
import LoginPage from './src/components/LoginPage/LoginPage';
import NovoEnderecoPage from './src/components/NovoEnderecoPage/NovoEnderecoPage';
import PedidoPage from './src/components/PedidoPage/PedidoPage';
import ProdutosPage from './src/components/ProdutosPage/ProdutosPage';
import VerificacaoPage from './src/components/VerificacaoPage/VerificacaoPage';
import { useEmpresa } from './src/redux/empresa/empresaHooks';
import store, { persistor } from './src/redux/store';
import { theme } from './src/theme';
import AlertDialog from './src/components/Generic/AlertDialog';
import { APP_NAME, APP_URL, SERVER_BASE } from './src/shared/constants';
import EsperaPedidoPage from './src/components/EsperaPedidoPage/EsperaPedidoPage';
import ListaSegundoSaborPage from './src/components/ListaSegundoSaborPage/ListaSegundoSaborPage';
import ProdutoNoPedido from './src/shared/entity/ProdutoNoPedido';
import PedidosPage from './src/components/PedidosPage/PedidosPage';
import SelecionarFilialPage from './src/components/SelecionarFilialPage/SelecionarFilialPage';
import PromocaoPage from './src/components/PromocaoPage/PromocaoPage';
import { useEmpresas } from './src/redux/empresas/empresasHooks';
import CadastrarCelularDialog from './src/components/Generic/CadastrarCelularDialog';
// import firebase from 'firebase';

// const firebaseConfig = {
//   apiKey: 'AIzaSyAVauUlQ04FXNYKvU5-fL4T5teEg-GQTqA',
//   authDomain: 'xismania-14380.firebaseapp.com',
//   projectId: 'xismania-14380',
//   storageBucket: 'xismania-14380.appspot.com',
//   messagingSenderId: '825464958536',
//   appId: '1:825464958536:web:45f5734fdae4ed366fb27d'
// };

// firebase.initializeApp(firebaseConfig);

const socket = socketIOClient(SERVER_BASE, {
  path: `/${APP_NAME}/socket.io`
  // withCredentials: false
});

export type StackParamList = {
  SelecionarFilialPage: {};
  LoginPage: undefined;
  CadastroPage: undefined;
  HomeDrawer: undefined;
  AdicionarProdutoPage: {
    id: number;
    editIndex?: number | undefined;
    primeiroSabor?: ProdutoNoPedido;
  };
  PedidoPage: undefined;
  NovoEnderecoPage: { refresh: () => Promise<void> };
  VerificacaoPage: undefined;
  PromocaoPage: { promocaoId: number };
  EsperaPedidoPage: { pedidoId: number };
  ListaSegundoSaborPage: { primeiroSabor: ProdutoNoPedido };
};

export type DrawerParamList = {
  ProdutosPage: undefined;
  PedidosPage: undefined;
};

const Stack = createStackNavigator<StackParamList>();
const AppNameStack = createStackNavigator();
const Drawer = createDrawerNavigator<DrawerParamList>();

function HomeDrawer() {
  return (
    <Drawer.Navigator
      screenOptions={{
        title: APP_NAME.charAt(0).toUpperCase() + APP_NAME.slice(1)
      }}
      drawerContent={(props) => <DrawerContent {...props} />}
    >
      <Drawer.Screen name="ProdutosPage" component={ProdutosPage} />
      <Drawer.Screen name="PedidosPage" component={PedidosPage} />
    </Drawer.Navigator>
  );
}

function MainStack() {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        title: APP_NAME.charAt(0).toUpperCase() + APP_NAME.slice(1)
      }}
      initialRouteName={'SelecionarFilialPage'}
    >
      <Stack.Screen name="SelecionarFilialPage" component={SelecionarFilialPage} />
      <Stack.Screen name="HomeDrawer" component={HomeDrawer} />
      <Stack.Screen name="LoginPage" component={LoginPage} />
      <Stack.Screen name="ListaSegundoSaborPage" component={ListaSegundoSaborPage} />
      <Stack.Screen name="CadastroPage" component={CadastroPage} />
      <Stack.Screen name="VerificacaoPage" component={VerificacaoPage} />
      <Stack.Screen name="AdicionarProdutoPage" component={AdicionarProdutoPage} />
      <Stack.Screen name="PedidoPage" component={PedidoPage} />
      <Stack.Screen name="EsperaPedidoPage" component={EsperaPedidoPage} />
      <Stack.Screen name="NovoEnderecoPage" component={NovoEnderecoPage} />
      <Stack.Screen name="PromocaoPage" component={PromocaoPage} />
    </Stack.Navigator>
  );
}

const AppContainer = (props) => {
  const [empresa, setEmpresa] = useEmpresa();
  const [empresas, setEmpresas] = useEmpresas();
  const dimensions = useWindowDimensions();
  const [openModalConexao, setOpenModalConexao] = useState(false);
  // const [openModalPlataforma] = useState(Platform.OS === 'web');

  const getEmpresas = async () => {
    try {
      const empresas = await empresaApi.getMany({});
      setEmpresas(empresas);
    } catch (err) {
      setOpenModalConexao(true);
      console.log(err);
    }
  };

  useEffect(() => {
    getEmpresas();
    socket.on('empresaAtualizada', getEmpresas);
    return () => {
      socket.off('empresaAtualizada');
    };
  }, []);

  useEffect(() => {
    if (empresas.length === 1) {
      setEmpresa(empresas[0]);
      return;
    }
    if (empresa) {
      const empresaAtualizada = empresas.find((emp) => emp.id === empresa.id);
      if (empresaAtualizada) {
        setEmpresa(empresaAtualizada);
        return;
      }
    }
  }, [empresas]);

  return (
    <View style={{ maxHeight: dimensions.height - 0.5, flex: 1 }}>
      {/* <BannerPlayStore podeMostrarBanner={openModalPlataforma} /> */}

      <CadastrarCelularDialog />

      <AlertDialog
        titulo={'Erro'}
        descricao={'Não foi possível contatar o servidor.'}
        show={openModalConexao}
        onClose={() => setOpenModalConexao(false)}
        actions={[
          {
            titulo: 'Tentar novamente',
            onPress: () => getEmpresas()
          }
        ]}
      />

      {props.children}
    </View>
  );
};

const linking = {
  prefixes: [APP_URL],
  config: {
    screens: {
      HomeDrawer: 'home',
      ProdutosPage: 'produtos',
      LoginPage: 'login',
      CadastroPage: 'cadastro',
      VerificacaoPage: 'verify',
      AdicionarProdutoPage: 'add',
      PedidoPage: 'pedido',
      NovoEnderecoPage: 'endereco/novo',
      EsperaPedidoPage: 'espera',
      SelecionarFilialPage: 'filial'
    }
  }
};
const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PaperProvider theme={theme}>
          <NavigationContainer linking={linking}>
            <AppContainer>
              <StatusBar backgroundColor={colors.primary} />
              <AppNameStack.Navigator screenOptions={{ headerShown: false }}>
                <AppNameStack.Screen name={APP_NAME} component={MainStack} />
              </AppNameStack.Navigator>
            </AppContainer>
          </NavigationContainer>
        </PaperProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
